import { connect } from 'react-redux';
import TwoFASettingsModal from "./TwoFASettingsModal";
import { getActiveModal, hideModal, MODAL_CHANGE_2FA_ENABLING } from "../../../../reducers/common/activeModal";
import { resetSubmitFormData, getSubmitFormSuccessStatus } from "../../../../reducers/common/submitForm";
import { getTranslation } from "../../../../reducers/common/localization";
import {
    is2FAEnable,
    getQRCodeData,
    getQRCodeDataLoading,
    fetchGenerate2FASecret,
    fetchEnable2FA,
    fetchDisable2FA
} from '../../../../reducers/account/security';
import { getUserEmail } from '../../../../reducers/account/userData';

const mapStateToProps = (state) => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_CHANGE_2FA_ENABLING,
        translation: getTranslation(state),
        is2FAEnable: is2FAEnable(state),
        QRCodeData: getQRCodeData(state),
        loadingQRCodeData: getQRCodeDataLoading(state),
        userEmail: getUserEmail(state),
        success: getSubmitFormSuccessStatus(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGenerate2FASecret: () => {
            dispatch(fetchGenerate2FASecret())
        },
        onEnable2FA: (checkCode) => {
            dispatch(fetchEnable2FA(checkCode))
        },
        onDisable2FA: () => {
            dispatch(fetchDisable2FA())
        },
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoFASettingsModal);



// WEBPACK FOOTER //
// ./src/components/accountManagement/securitySettings/twoFASettingsModal/TwoFASettingsModal.container.js